import React from 'react';

const Resume = () => {
  return (
    <div className="flex flex-col h-full bg-white">
      {/* Toolbar */}
      <div className="bg-[#ece9d8] border-b border-gray-300 px-2 py-1 flex items-center gap-2 text-xs">
        <button 
          className="px-2 py-1 hover:bg-[#d4d0c8] border border-transparent hover:border-gray-400"
          onClick={() => window.open('/resume.pdf', '_blank')}
        >
          📄 Open in New Tab
        </button>
        <button 
          className="px-2 py-1 hover:bg-[#d4d0c8] border border-transparent hover:border-gray-400"
          onClick={() => {
            const link = document.createElement('a');
            link.href = '/resume.pdf';
            link.download = 'Vimarsh_Tiwari_Resume.pdf';
            link.click();
          }}
        >
          💾 Download
        </button>
        <div className="flex-1"></div>
        <span className="text-gray-600">Adobe Acrobat Document</span>
      </div>

      {/* PDF Viewer */}
      <div className="flex-1 overflow-hidden bg-gray-200 flex items-center justify-center">
        <iframe
          src="/resume.pdf"
          className="w-full h-full border-0"
          title="Vimarsh Tiwari Resume"
          style={{
            backgroundColor: '#525659'
          }}
        />
      </div>

      {/* Status Bar */}
      <div className="bg-[#ece9d8] border-t border-gray-300 px-2 py-1 text-xs text-gray-700 flex items-center justify-between">
        <span>📄 Vimarsh_Tiwari_Resume.pdf</span>
        <span>Ready</span>
      </div>
    </div>
  );
};

export default Resume;
